import { sortBy } from "lodash-es";
import { defineStore } from "pinia";

import type { ServerTime, TimerEvent } from "@/model/timer";

import { useArtStore } from "./art";
import { useBoardStore } from "./board";

export const useTimerStore = defineStore("timer", {
  state: () => ({
    timers: [] as TimerEvent[],
    active: false,
  }),
  getters: {
    boardTimers(): TimerEvent[] {
      return this.timers.filter(isBoard);
    },
    artTimers(): TimerEvent[] {
      return this.timers.filter(isArt);
    },
    lowestRunningTimer:
      (state) =>
      (now: ServerTime): TimerEvent | undefined => {
        const running = state.timers.filter(
          (timer) =>
            timer.data.state === "running" &&
            timer.data.end >= now &&
            (isBoard(timer) || isArt(timer)),
        );
        return sortBy(running, (timer) => timer.data.end)[0];
      },
  },
  actions: {
    toggleTimer() {
      this.active = !this.active;
    },
  },
});

function isBoard(timer: TimerEvent) {
  return timer.boardId && timer.boardId === useBoardStore().board?.id;
}

function isArt(timer: TimerEvent) {
  return !timer.boardId && useArtStore().isCurrentArt(timer.artId);
}
